export default __webpack_public_path__ + "static/27-30 Agrawal et al-e4ab07c053eb7e6706d821a1da295927.pdf";